// components/VitalsModal.js
import React from 'react';
import Modal from '../../shared/components/UIElements/Modal';
import Button from '../../shared/components/FormElements/Button';
import './VitalsModal.css'; // optional for styling

const VitalsModal = ({ show, onCancel, onSave, vitalsForm, setVitalsForm }) => {
  const fields = [
    'height',
    'weight',
    'bloodGroup',
    'comorbidities',
    'allergies',
    'pastAllergies',
    'identificationMarks'
  ];

  const inputChangeHandler = (e) => {
    const { name, value } = e.target;
    setVitalsForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <Modal
      show={show}
      onCancel={onCancel}
      header="Update Vitals & Additional Info"
      footerClass="modal-actions"
      footer={
        <>
          <Button inverse type="button" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" onClick={onSave}>
            Save
          </Button>
        </>
      }
    >
      <p className="muted">
        Only fill in the details you want to update. Blank fields keep their last saved value.
      </p>
      <div className="vitals-form">
        {fields.map((field) => (
          <div key={field} className="vitals-field">
            <label htmlFor={`vital-${field}`}>{field.replace(/([A-Z])/g, ' $1')}</label>
            <input
              id={`vital-${field}`}
              type="text"
              name={field}
              value={vitalsForm[field] || ''}
              onChange={inputChangeHandler}
            />
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default VitalsModal;
